import angular from 'angular';
import { FormInputDirectiveModule } from '../../formInput/formInput.directive';
import { RatingsDirectiveModule } from '../../ratings/ratings.directive';
import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';

export const ReviewCreateDirectiveModule = angular.module('acme.common.directive.review.create', [
  AnalyticsServiceModule,
  RatingsDirectiveModule,
  FormInputDirectiveModule
])
.directive('reviewCreate', ['AnalyticsService', function(AnalyticsService) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/review/create/create.tpl.html',
      scope: {
        model: '=',
        minRating: '@',
        reviewCreateDone: '&',
        reviewCreateCancel: '&'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.reviewCreate = {

          title: '',
          comment: '',
          rating: -1,
          isComplete: false,
          isSubmitted: false,
          isValidRating: true,

          init: function() {
            $scope.$watch('reviewCreate.rating', this.onReviewCreateRatingUpdate);
            if ($scope.model) {
              this.title = $scope.model.title || '';
              this.comment = $scope.model.comment || '';
              this.rating = $scope.model.rating || '';
            }
          },

          done: function() {
            $scope.model.title = this.title;
            $scope.model.rating = this.rating;
            $scope.model.comment = this.comment;
            this.isSubmitted = true;
            this.checkRating();
            if (this.isValidRating) {
              $scope.reviewCreateDone();
              this.isComplete = true;
              AnalyticsService.event({
                name: 'Review::Done',
                category: 'Reviews',
                label: 'Rating: ' + this.rating
              });
            }
          },

          cancel: function() {
            this.isSubmitted = false;
            this.isComplete = false;
            AnalyticsService.event({
              name: 'Review::Cancel',
              category: 'Reviews'
            });
            $scope.reviewCreateCancel();
          },

          checkRating: function() {
            if (this.isSubmitted) {
              this.isValidRating = (this.rating >= $scope.minRating);
            }
          },

          onReviewCreateRatingUpdate: function(n, o) {
            console.log('ReviewCreate::onReviewCreateRatingUpdate', n, o);
            $scope.reviewCreate.checkRating();
          }
        };

        $scope.reviewCreate.init();

      }]

    };

}]).name;
